export const contentTypeRecord: Record<string, string> = {
  aac: 'audio/aac',
  ai: 'application/pdf',
  avi: 'video/x-msvideo',
  bmp: 'image/bmp',
  blend: 'application/octet-stream',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  eps: 'image/x-eps',
  fbx: 'application/octet-stream',
  flac: 'audio/flac',
  gif: 'image/gif',
  jpg: 'image/jpeg',
  key: 'application/x-iwork-keynote-sffkey',
  mkv: 'video/x-matroska',
  mov: 'video/quicktime',
  mp3: 'audio/mpeg',
  mp4: 'video/mp4',
  obj: 'text/plain',
  ogg: 'audio/ogg',
  pdf: 'application/pdf',
  png: 'image/png',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  psb: 'application/vnd.3gpp.pic-bw-small',
  psd: 'image/vnd.adobe.photoshop',
  rtf: 'application/rtf',
  skp: 'application/vnd.sketchup.skp',
  step: 'text/plain',
  stp: 'text/plain',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  txt: 'text/plain',
  wav: 'audio/wav',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
